var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "loading",
      class: { "loading--with-message": !!_vm.message }
    },
    [
      !!_vm.message ? _c("span", [_vm._v(_vm._s(_vm.message))]) : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "lds-ellipsis",
          class: { "lds-ellipsis--with-message": !!_vm.message }
        },
        [
          _c("div"),
          _vm._v(" "),
          _c("div"),
          _vm._v(" "),
          _c("div"),
          _vm._v(" "),
          _c("div")
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-44238957", { render: render, staticRenderFns: staticRenderFns })
  }
}